"use client";
import { rem } from "../../../../utils/units-converters/rem.mjs";
import { colorResolver } from "../color-resolver/color-resolver.mjs";
//#region packages/@mantine/core/src/core/Box/style-props/resolvers/border-resolver/border-resolver.ts
function borderResolver(value, theme) {
	if (typeof value === "number") return rem(value);
	if (typeof value === "string") {
		const [size, style, ...colorTuple] = value.split(" ").filter((val) => val.trim() !== "");
		let result = `${rem(size)}`;
		style && (result += ` ${style}`);
		colorTuple.length > 0 && (result += ` ${colorResolver(colorTuple.join(" "), theme)}`);
		return result.trim();
	}
	return value;
}
//#endregion
export { borderResolver };

//# sourceMappingURL=border-resolver.mjs.map